import { assignTabDataAndDispatch } from 'state/tabs/actions';
import * as types from './constants';

export function setSelectedForm(formType) {
  return assignTabDataAndDispatch({ type: types.SET_SELECTED_FORM, formType });
}
